<div class="login-fullscreen">
  <div class="visual-pane" aria-hidden="true">
    <div class="visual-overlay">
      <img src="https://applisound-images.s3.eu-west-3.amazonaws.com/images-grosses/landing-collage.jpg" alt="" />
    </div>
    <!-- Language selector anchored to the pane -->
    <div class="lang-on-pane">
      <app-language-selector [showTitle]="false"></app-language-selector>
    </div>
  </div>

  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <a [routerLink]="getRouterLink('')">
          <img
            src="https://applisound-images.s3.eu-west-3.amazonaws.com/applisound-bleu.png"
            alt="Applisound logo"
            draggable="false"
            class="no-drag"
            />
        </a>
        <h1>{{ "LOGIN.WELCOME_BACK" | translate }}</h1>
        <p>{{ "LOGIN.SUBTITLE" | translate }}</p>
      </div>

      <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="email">{{ "LOGIN.EMAIL" | translate }}</label>
          <input
            type="email"
            id="email"
            formControlName="email"
            [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
            [ngClass]="{ invalid: submitted && f['email'].errors }"
            />
          @if (submitted && f['email'].errors) {
            <div class="error-message">
              @if (f['email'].errors?.['required']) {
                <span>{{
                  "LOGIN.EMAIL_REQUIRED" | translate
                }}</span>
              }
              @if (f['email'].errors?.['email']) {
                <span>{{
                  "LOGIN.EMAIL_INVALID" | translate
                }}</span>
              }
            </div>
          }
        </div>

        <div class="form-group">
          <div class="password-label">
            <label for="password">{{ "LOGIN.PASSWORD" | translate }}</label>
            <a
              [routerLink]="getRouterLink('forgot-password')"
              class="forgot-link"
              >
              {{ "LOGIN.FORGOT_PASSWORD" | translate }}
            </a>
          </div>
          <div class="password-input">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
              [ngClass]="{ invalid: submitted && f['password'].errors }"
              />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              >
              <i
                class="fa"
                [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
              ></i>
            </button>
          </div>
          @if (submitted && f['password'].errors) {
            <div class="error-message">
              @if (f['password'].errors?.['required']) {
                <span>{{
                  "LOGIN.PASSWORD_REQUIRED" | translate
                }}</span>
              }
            </div>
          }
        </div>

        <div class="remember-me">
          <label class="checkbox-container">
            <input type="checkbox" formControlName="rememberMe" />
            <span class="checkmark"></span>
            {{ "LOGIN.REMEMBER_ME" | translate }}
          </label>
        </div>

        <button type="submit" class="btn-login-submit" [disabled]="loading">
          @if (!loading) {
            <span>{{ "LOGIN.SIGN_IN" | translate }}</span>
          }
          @if (loading) {
            <span class="spinner"></span>
          }
        </button>

        <div class="login-divider">
          <span>{{ "LOGIN.OR" | translate }}</span>
        </div>

        <div class="social-login">
          <button type="button" class="btn-social google">
            <i class="fab fa-google"></i> Google
          </button>
          <button type="button" class="btn-social facebook">
            <i class="fab fa-facebook-f"></i> Facebook
          </button>
        </div>
      </form>

      @if (errorMessage) {
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      }

      <div class="signup-prompt">
        <p>
          {{ "LOGIN.NO_ACCOUNT" | translate }}
          <a [routerLink]="getRouterLink('signup')">{{
            "LOGIN.SIGN_UP" | translate
          }}</a>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Mobile-only selector (visual pane hidden on mobile) -->
<div class="lang-mobile light">
  <app-language-selector [showTitle]="false"></app-language-selector>

</div>
